/*
 *
 * Package: `@dbh/dropdown-menu-theme`.
 *
 */const THEME_KEY_DROP_DOWN_MENU="dropDownMenu";const modifyDropDownMenuTheme=a=>{let{colors:{white:b,greyUltralight:c},spacing:{sp3:d,sp4:e,sp5:f,sp6:g,sp7:h,sp18:i,sp20:j,sp23:k}}=a;return {[THEME_KEY_DROP_DOWN_MENU]:{items:{arrowColor:b,arrowHeight:g,headerColor:c,width:k,headerPadding:e+" "+f,headerHeight:"auto",lineHeight:"inherit",itemWidth:i,itemHeight:"auto",itemPadding:d+" "+e,margin:h+" 0",right:j,flex:"unset",withTwoOrMoreColumns:!1}}}};

export { THEME_KEY_DROP_DOWN_MENU, modifyDropDownMenuTheme as default };
